<script>
import IconTrash from './icons/Trash';

export default {
  data () {
    return {
      isReady: false,
    };
  },
  methods: {
    handleReadyChange () {
      this.isReady = !this.isReady;
    },
    handleConfirm () {
      this.$emit('confirm');
    },
  },
  render () {
    const { $style, isReady } = this;

    return (
      <div class={$style.wrapper}>
        {!isReady ? (
          <u-btn
            appearance="outline"
            color="danger"
            size="square"
            onClick={this.handleReadyChange}
          >
            <IconTrash />
          </u-btn>
        ) : (
          <span class={$style.confirm}>
            <span class={$style.confirmText}>
              Вы уверены?
            </span>
            <u-btn
              appearance="control"
              class={[$style.confirmBtn, $style.delete]}
              onClick={this.handleConfirm}
            >
              да
            </u-btn>
            <u-btn
              appearance="control"
              class={[$style.confirmBtn, $style.cancel]}
              onClick={this.handleReadyChange}
            >
              нет
            </u-btn>
          </span>
        )}
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.confirm {
  align-items: center;
  display: inline-flex;

  &Text,
  &Btn {
    font-size: .825em;
  }

  &Btn {
    &.cancel {
      color: $color-primary;
    }

    &.delete {
      color: $color-red-darkest;
    }
  }
}
</style>
